export default __webpack_public_path__ + "static/media/customizedApproachImg.73b83ad3.png";